module.exports = __webpack_public_path__ + "static/media/freeVideo.e6a71d14.png";